import { initI18n } from '../shared/app/i18n/index.js';
// Bootstrap CSS is loaded (and swapped LTR/RTL) at runtime by i18n/index.ts, depending on the locale.
import 'bootstrap/js/src/collapse.js';
import 'bootstrap/js/src/offcanvas.js';
import './base.styl';
import './vue/halloween/halloween.css';

import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { createHead } from '@unhead/vue/client';
import App from './vue/App.vue';
import router from './vue/router.js';
import unoverlay from '@overlastic/vue';
import usePlayerLocalSettingsStore from './stores/playerLocalSettingsStore.js';
import useAuthStore from './stores/authStore.js';
import I18NextVue from 'i18next-vue';
import i18next from 'i18next';
import useMatomo from './vue/useMatomo.js';
import './services/registerServiceWorker.js';
import './services/playerActivity.js';
import { preloadAssets } from './services/preload-assets.js';
import { halloween } from './services/halloween.js';
import './services/notifications/index.js';

const pinia = createPinia();

const vueApp = createApp(App);
vueApp.use(router);
vueApp.use(pinia);
vueApp.use(I18NextVue, { i18next });
vueApp.use(unoverlay);
vueApp.use(createHead());

useMatomo(vueApp);

// Load store now to set dark/light theme early enough and prevent blinking
usePlayerLocalSettingsStore();

if (halloween) {
    document.documentElement.classList.add('halloween');
}

// authStore and socketStore reference each other.
// authStore must be the one initialized first, else socketStore would be
// initialized while still partial.
useAuthStore();

void preloadAssets();

await initI18n();

vueApp.mount('#vue-app');
